// eslint-disable-next-line import/no-cycle
import WorkshopCommentsBlock from './WorkshopCommentsBlock';

export default WorkshopCommentsBlock;
